import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {ServicesTable} from "./components/ServicesTable";
import {getServices} from "../../store/reducers/ServicesSlice";

interface SetvicesScreenProps {
}

export const ServicesScreen: React.FC<SetvicesScreenProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getServices(false));
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Teenuse tüübid</h1>
            <ServicesTable />
            </LoggedInView>
    )

}